import { lazy } from 'react';
const salinq = lazy(() => import('./salinq'));

const salinqRoutes = [
  {
    path: '/salinq',
    component: salinq
  }
];

export default salinqRoutes;